import React, { useEffect } from "react"
import { Grid, Typography } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import { TEXT_PRIMARY_COLOR, TEXT_SECONDARY_COLOR, FONT_FAMILY_PRIMARY, FONT_FAMILY_SECONDARY } from "../../theme"
import Modal from "./Modal"
import { CODIGO_TECLA_U, CODIGO_TECLA_ESC } from "../utils/Constantes"

const ModalCadastroAmostrasSucesso = ({
    paciente,
    etiqueta,
    tipo,
    modalAberto,
    setModalAberto,
    handleClickBotaoPrincipalModal,
    handleClickBotaoSecundarioModal,
    carregandoModal }) => {

    const classes = useStyles()

    const handleFecharModal = () => {
        setModalAberto(false)
    };

    useEffect(() => {
        const registerShortcut = (event) => {
            if (event.ctrlKey && event.which === CODIGO_TECLA_U) {
                event.preventDefault();
                handleClickBotaoSecundarioModal();
            }
        }

        document.addEventListener('keydown', registerShortcut);

        return () => document.removeEventListener('keydown', registerShortcut);
    }, [handleClickBotaoSecundarioModal]);

    useEffect(() => {
        const goBackListShortcut = (event) => {
            if (event.which === CODIGO_TECLA_ESC) {
                event.preventDefault();
                handleClickBotaoPrincipalModal();
            }
        }

        document.addEventListener('keydown', goBackListShortcut);

        return () => document.removeEventListener('keydown', goBackListShortcut);

    }, [handleClickBotaoPrincipalModal]);

    return (
        <Modal
            modalAberto={modalAberto}
            desabilitarCliqueForaModal={false}
            iconeFechar={true}
            titulo={"Amostra cadastrada com sucesso!"}
            maxWidth={"sm"}
            fecharModal={handleFecharModal}
            desativarTeclaEsc={true}
            botaoPrincipal={{
                texto: "Listagem de amostras",
                acao: () => handleClickBotaoPrincipalModal(),
                carregando: carregandoModal,
                atalho: "(ESC)"
            }}
            botaoSecundario={{
                texto: "Novo cadastro",
                acao: () => handleClickBotaoSecundarioModal(),
                carregando: carregandoModal,
                atalho: "(CTRL + U)"
            }}
            className={classes.modalCadastroAmostrasSucesso}
        >
            <Grid container className={"pr-2 pl-2 pt-50 pb-5"}>
                <Grid align="center" item xs={12}>
                    <Typography className={classes.gridPaciente}>
                        Paciente: {paciente}
                    </Typography>
                </Grid>
                <Grid align="center" item xs={12}>
                    <Typography className={classes.gridDados}>
                        <Grid>
                            Etiqueta: {etiqueta}
                        </Grid>
                        <Grid>
                            Tipo: {tipo}
                        </Grid>
                    </Typography>
                </Grid>
            </Grid>
        </Modal>
    )
}

const useStyles = makeStyles((theme) => ({
    modalCadastroAmostrasSucesso: {},
    gridPaciente: {
        width: "340px",
        height: "42px",
        left: "446px",
        top: "326px",

        fontFamily: FONT_FAMILY_SECONDARY,
        fontSize: "16px",
        lineHeight: "19px",
        textAlign: "center",

        color: TEXT_PRIMARY_COLOR
    },
    gridDados: {
        width: "340px",
        height: "45px",
        left: "446px",
        top: "355px",

        fontFamily: FONT_FAMILY_PRIMARY,
        fontSize: "16px",
        lineHeight: "19px",
        textAlign: "center",

        color: TEXT_SECONDARY_COLOR
    },
}))

export default ModalCadastroAmostrasSucesso